/* eslint-disable no-undef */
import api from "./ApiService";

const getRoles = (data?: any) => {
  return api
    .get(process.env.REACT_APP_API_BASE_URL + `/roles?${data}`)
    .then((response: any) => {
      return response;
    });
};

const RolesService = {
  getRoles,
};
export default RolesService;
